export const irsGetTaxReturnLink =
  'https://www.irs.gov/individuals/get-transcript';
export const irsEosLink = 'https://apps.irs.gov/app/eos';
